namespace Roodik.Game
{
	export class ReshuffleStrategy
	{
		private _countAttempt:number = 0;
		
		constructor(private _columns:Array<string>,
		            private _getTilesWhichCanBeMatched:()=>Array<IPairOfTiles>)
		{
		}
		
		public shuffle(tiles:Array<ITileModel>, isSolvableProbability:boolean)
		{
			this._countAttempt = 0;
			this.shuffleInternal(isSolvableProbability, tiles);
		}
		
		private shuffleInternal(isSolvableProbability : boolean, tiles : Array<Roodik.Game.ITileModel>)
		{
			let strategy : IShuffleStrategy;

			strategy = new SolvableStrategy(this._columns, tiles);
			strategy.shuffle();
			if (this._countAttempt <= 3 && this._getTilesWhichCanBeMatched().length == 0)
			{
				this._countAttempt++;
				this.shuffleInternal(isSolvableProbability, tiles);
			}
		}
		
		public destroy()
		{
			this._getTilesWhichCanBeMatched = null;
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/Model/Reshuffle/ReshuffleStrategy.ts